<template>
  <div class="FieldList">
    <FieldLabel
      v-if="label"
      :label="label" />
    <Empty :for="items">
      {{ $t('empty') }}
    </Empty>
    <RowFlex
      v-for="(item, index) in items"
      :key="index"
      class="item">
      <Icon
        v-if="isCheckable"
        :class="{ checked: itemsChecked.includes(item) }"
        :name="itemsChecked.includes(item) ? 'check' : 'cross'"
        @click="toggleCheck(item)" />
      <slot
        v-if="$scopedSlots.field"
        :index="index"
        :item="item"
        name="field"
        :removeItem="() => removeItem(index)"
        :setItem="value => setItem(index, value)" />
      <Field
        v-else
        :label="labels && labels[index]"
        :type="type"
        :value="item"
        @keydown.delete.native="considerDeleting(index)"
        @update:value="setItem(index, $event)" />
    </RowFlex>
    <RowFlex class="constrainButtons">
      <Btn class="sm light" @click="$emit('add')">
        {{ $t('add') }}
      </Btn>
      <slot name="foot" />
    </RowFlex>
  </div>
</template>

<script>
import { removeIndex } from '@utils/collections'

export default {
  props: {
    isCheckable: { type: Boolean, default: false },
    items: Array,
    itemsChecked: Array,
    label: String,
    labels: Array,
    type: { type: String, default: 'text' },
  },
  methods: {
    considerDeleting(index) {
      const value = this.items[index]

      if (!value) return this.removeItem(index)
    },
    toggleCheck(item) {
      this.$emit('check', item)
    },
    setItem(index, value) {
      this.$up(['items', index], value)
    },
    setItems(items) {
      this.$up('items', items)
    },
    removeItem(index) {
      this.setItems(removeIndex(index, this.items))
    },
  },
}
</script>

<style lang="scss">
.FieldList {
  .item {
    align-items: flex-start;

    .Icon {
      background: $neutral-lighter;
      border: 1px solid $neutral;
      border-radius: $radius;
      cursor: pointer;
      font-size: $h6;
      padding: 0.5rem;

      &.checked {
        background: $success-lighter;
        border-color: $success;
        color: $success-dark;

        &:hover {
          background: transparent;
        }
      }

      &:hover {
        background: $success-lighter;
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "add": "Add",
    "empty": "No items"
  }
}
</i18n>
